"use strict";
/**
 * extracted from utilities - makeSafeFrame 1678
 * file is fine, same as prod.
 *
 * Creates a safe frame with an id based on the placement you pass in with a
 * starting width and height that you pass in. does not add it to the DOM
 */
Object.defineProperty(exports, "__esModule", { value: true });
function makeSafeFrame(placement, width, height) {
    var frame = document.createElement("iframe");
    frame.setAttribute("id", placement + "-frame");
    frame.setAttribute("FRAMEBORDER", "0");
    frame.setAttribute("SCROLLING", "no");
    frame.setAttribute("MARGINHEIGHT", "0");
    frame.setAttribute("MARGINWIDTH", "0");
    frame.setAttribute("TOPMARGIN", "0");
    frame.setAttribute("LEFTMARGIN", "0");
    frame.setAttribute("ALLOWTRANSPARENCY", "true");
    frame.setAttribute("width", width);
    frame.setAttribute("height", height);
    return frame;
}
exports.default = makeSafeFrame;
